import { Text, View } from '@react-pdf/renderer'
import PDFPage from '@/components/ReportPDF/PDFPage'
import PDFTitle from '@/components/ReportPDF/PDFTitle'
import PDFParagraph from '@/components/ReportPDF/PDFParagraph'
import { formatYearMonth } from '../../TaiwanDateConvert'

const Chapter4Page = ({ reportData, setPage }) => {
  const { reprotDao } = reportData || {}
  const { companyName, campaignStartDate } = reprotDao || {}

  return (
    <PDFPage hideTitleDivider reportData={reportData}>
      <PDFTitle hideDivider>4.4 受測者釣中行為清單</PDFTitle>
      <Text
        render={({ pageNumber }) => {
          setPage({ chap4_4: pageNumber })
        }}
      />

      <View>
        <PDFParagraph>
          <Text>
            依據受測者演練之釣中行為，詳列之「瀏覽郵件」與「點閱連結」與「開啟附件」等受清單。
          </Text>
        </PDFParagraph>

        <PDFParagraph>
          <Text>
            請查閱附件：{companyName}_社交工程郵件演練服務結果_各類清單_
            {formatYearMonth(campaignStartDate)}.xlsx
          </Text>
        </PDFParagraph>

        <PDFParagraph>
          <Text style={{ fontFamily: 'BiauKai' }}>■ </Text>
          <Text>頁籤資訊-{companyName}_釣中清單</Text>
        </PDFParagraph>

        <PDFParagraph>
          <Text style={{ fontFamily: 'BiauKai' }}>■ </Text>
          <Text>頁籤資訊-瀏覽郵件 點閱連結 開啟附件_結果清單</Text>
        </PDFParagraph>

        <PDFParagraph>
          <Text style={{ fontFamily: 'BiauKai' }}>■ </Text>
          <Text>頁籤資訊-部門釣中_結果清單</Text>
        </PDFParagraph>
      </View>
    </PDFPage>
  )
}

export default Chapter4Page
